import { ClickAwayListener } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import { RedirectToLogin } from '@wm/login-redirect-library';
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IState } from '../../../../config/rootReducer';
import { LOGOUT_REDIRECT } from '../../../../config/envVariables';
import { UserAvatar, UserFullName } from '../../../Profile/actions/ProfileActions';
import { HideProfilePopup } from '../../actions/ApplicationActions';
import { ProfilePopupStyle } from './ProfilePopupStyle';
import { LogOutAction } from '../../../Login/actions/LoginActions';

// const i18n_viewProfile = 'Ver perfil'
const i18nLogout = 'Cerrar Sesión';

const ProfilePopup = ({ open, anchor }) => {
  const classes = ProfilePopupStyle();
  const dispatch = useDispatch();
  const firstName = useSelector((state: IState) => state.profile.user.firstName);
  const lastName = useSelector((state: IState) => state.profile.user.lastName);
  const email = useSelector((state: IState) => state.profile.user.email);
  const client = useSelector((state: IState) => state.profile.client.name);
  const hideProfilePopup = HideProfilePopup(dispatch);

  const Logout = () => {
    dispatch(LogOutAction());
    RedirectToLogin(`${LOGOUT_REDIRECT}/close`, []);
  };

  return (
    <Popper
      open={open}
      anchorEl={anchor}
      placement="right-end"
      className={classes.container}
      transition={true}
    >
      {({ TransitionProps }) => (
        <ClickAwayListener onClickAway={hideProfilePopup}>
          <Fade {...TransitionProps} timeout={350}>
            <Paper className={`${classes.gridContainer} profilepopupReference`}>
              <Grid
                container={true}
                direction="column"
                className={`${classes.gridContainer} observable`}
              >
                <Grid item={true}>
                  <Grid container={true} direction="row">
                    <Grid item={true} className={classes.avatarGrid}>
                      <Avatar className={classes.avatarIcon}>
                        {UserAvatar(firstName, lastName)}
                      </Avatar>
                    </Grid>
                    <Grid item={true} className={classes.infoGrid}>
                      <Typography>{UserFullName(firstName, lastName)}</Typography>
                      <Typography>{email}</Typography>
                      <Typography>{client}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item={true} className={classes.horizontalDivider} />
                <Grid item={true}>
                  <Button onClick={Logout} className={classes.logoutButton}>
                    {i18nLogout}
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Fade>
        </ClickAwayListener>
      )}
    </Popper>
  );
};

export default ProfilePopup;
